import LessonView from "src/components/NewComponents/Views/ScoreViews/LessonView";

export const getExamRowFromLesson = (lesson: any) => {
	return {
		name: lesson.name,
		exam: lesson.exam,
		lessonStatus: lesson.status,
		startDate: lesson.startDate,
		day: lesson.day,
		allItems: lesson.itemsIds.length,
		lessonId: lesson.id,
		courseId: lesson.courseId,
	};
};

interface ExamLessonProps {
	lesson: any;
	className?: string;
	folders?: { id: string | number; name: string; details?: { color?: string | null } | null }[];
}

export const ExamLesson = ({ lesson, className, folders = [] }: ExamLessonProps) => {
	return (
		<LessonView
			className={className}
			key={lesson.id}
			row={getExamRowFromLesson(lesson)}
			lesson={lesson}
			folders={folders}
		/>
	);
};
